// La Campelière — minimal progressive-enhancement JS.
// All interactions degrade gracefully when JS is unavailable.

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Mobile nav toggle
  function setupMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-nav]');
    var close = document.querySelector('[data-menu-close]');
    if (!toggle || !menu) return;

    function open() {
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstLink = menu.querySelector('a');
      if (firstLink) firstLink.focus();
    }
    function shut() {
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') shut();
    });
  }

  // PDP gallery — thumb swap, no library
  // Swap the main image to the thumb matching a Shopify media id. Returns false
  // when the id is empty or no matching thumb exists (e.g. image-only variant).
  function updateGallerySwatch(gallery, label) {
    if (!gallery) return;
    var swatch = gallery.querySelector('[data-gallery-swatch]');
    if (!swatch) return;
    swatch.textContent = label || '';
    swatch.hidden = !label;
  }

  function activateMediaById(gallery, mediaId) {
    if (!gallery || !mediaId) return false;
    var thumb = gallery.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    var main = mainWrap ? mainWrap.querySelector('img') : null;
    if (!thumb || !main) return false;
    var src = thumb.getAttribute('data-src');
    var srcset = thumb.getAttribute('data-srcset');
    var alt = thumb.getAttribute('data-alt') || '';
    var label = thumb.getAttribute('data-variant-label') || '';
    if (src) main.setAttribute('src', src);
    if (srcset) main.setAttribute('srcset', srcset);
    main.setAttribute('alt', alt);
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
    thumb.setAttribute('aria-pressed', 'true');
    mainWrap.setAttribute('data-media-id', mediaId);
    updateGallerySwatch(gallery, label);
    return true;
  }

  function activateMediaImage(gallery, mediaId, src, srcset, alt, label) {
    if (!gallery || !src) return;
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    var main = mainWrap ? mainWrap.querySelector('img') : null;
    if (!main) return;
    main.setAttribute('src', src);
    if (srcset) main.setAttribute('srcset', srcset);
    main.setAttribute('alt', alt || '');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
    if (mainWrap && mediaId) mainWrap.setAttribute('data-media-id', mediaId);
    updateGallerySwatch(gallery, label || '');
  }

  function setupGallery() {
    var galleries = document.querySelectorAll('[data-gallery]');
    galleries.forEach(function (g) {
      var main = g.querySelector('[data-gallery-main] img');
      var thumbs = g.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          activateMediaById(g, t.getAttribute('data-media-id'));
        });
      });
    });
  }

  // Quantity stepper
  function setupQuantity() {
    document.querySelectorAll('[data-quantity]').forEach(function (q) {
      var input = q.querySelector('input');
      var minus = q.querySelector('[data-qty-minus]');
      var plus = q.querySelector('[data-qty-plus]');
      if (!input) return;
      function set(v) {
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10) || 999;
        v = Math.max(min, Math.min(max, v));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    });
  }

  // Variant picker — single-option products only.
  // Updates hidden form input and pushes the variant id; reloads price/availability via fetch /products/<handle>.js
  function setupVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      // The picker block is a sibling of the form block, not a child.
      var form = document.querySelector('form[data-product-form]');
      var hidden = form ? form.querySelector('input[name="id"]') : null;
      var options = picker.querySelectorAll('[data-variant-option]');
      if (!hidden || !options.length) return;
      // Gallery lives in the same product section; fall back to the page's only gallery.
      var gallery = (picker.closest('section') || document).querySelector('[data-gallery]');

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var id = opt.getAttribute('data-variant-id');
          var available = opt.getAttribute('data-available') === 'true';
          if (!available) return;
          options.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
          opt.setAttribute('aria-checked', 'true');
          hidden.value = id;
          var mediaId = opt.getAttribute('data-featured-media-id');
          if (!activateMediaById(gallery, mediaId)) {
            activateMediaImage(
              gallery,
              mediaId,
              opt.getAttribute('data-featured-image-src'),
              opt.getAttribute('data-featured-image-srcset'),
              opt.getAttribute('data-featured-image-alt'),
              opt.getAttribute('data-featured-variant-label')
            );
          }
          var priceEl = document.querySelector('[data-product-price]');
          var price = opt.getAttribute('data-price');
          if (priceEl && price) {
            // Rebuild the price block so the strikethrough compare price and the
            // unit price survive a variant switch (textContent would flatten them).
            var compare = opt.getAttribute('data-compare-price');
            var unit = opt.getAttribute('data-unit-price');
            var html = '';
            if (compare) html += '<span class="price__compare">' + compare + '</span>';
            html += '<span class="price">' + price + '</span>';
            if (unit) html += '<span class="price__unit">' + unit + '</span>';
            priceEl.innerHTML = html;
          }
          // Per-variant conditionnement + MOQ (B2B) — toggle row visibility so a
          // variant with a value reveals its row even when the initially loaded
          // variant had none (server renders the scaffold rows `hidden`).
          var cond = opt.getAttribute('data-conditionnement');
          var condRow = document.querySelector('[data-variant-conditionnement-row]');
          var condEl = document.querySelector('[data-variant-conditionnement]');
          if (condEl) condEl.textContent = cond || '';
          if (condRow) condRow.hidden = !cond;
          var moq = parseInt(opt.getAttribute('data-moq'), 10);
          var hasMoq = moq > 0;
          var moqRow = document.querySelector('[data-variant-moq-row]');
          var moqEl = document.querySelector('[data-variant-moq]');
          if (moqEl) moqEl.textContent = hasMoq ? moq : '';
          if (moqRow) moqRow.hidden = !hasMoq;
          var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
          if (qtyInput) {
            var newMin = hasMoq ? moq : 1;
            qtyInput.setAttribute('min', newMin);
            if ((parseInt(qtyInput.value, 10) || 1) < newMin) qtyInput.value = newMin;
          }
          // Update URL for shareability without reloading
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* ignore */ }
        });
      });

      // Sync the gallery with the variant checked on load (?variant= deep-links
      // and the Pro/Particulier Tarif reassignment).
      var checked = picker.querySelector('[data-variant-option][aria-checked="true"]');
      if (checked && !activateMediaById(gallery, checked.getAttribute('data-featured-media-id'))) {
        activateMediaImage(
          gallery,
          checked.getAttribute('data-featured-media-id'),
          checked.getAttribute('data-featured-image-src'),
          checked.getAttribute('data-featured-image-srcset'),
          checked.getAttribute('data-featured-image-alt'),
          checked.getAttribute('data-featured-variant-label')
        );
      }
    });
  }


  // Contact page — live character counter only. Native validation and Shopify
  // contact form submission remain the source of truth.
  function setupContactMessageCounter() {
    document.querySelectorAll('[data-contact-message]').forEach(function (textarea) {
      var form = textarea.closest('form');
      var counter = form ? form.querySelector('[data-contact-message-count]') : null;
      if (!counter) return;
      var max = parseInt(textarea.getAttribute('maxlength'), 10) || 2000;
      function update() {
        counter.textContent = textarea.value.length + '/' + max;
      }
      textarea.addEventListener('input', update);
      update();
    });
  }

  // Facets — mobile drawer toggle (sidebar stays static on desktop)
  function setupFacetsDrawer() {
    var toggle = document.querySelector('[data-facets-toggle]');
    var panel = document.querySelector('[data-facets-panel]');
    var scrim = document.querySelector('[data-facets-scrim]');
    var close = document.querySelector('[data-facets-close]');
    if (!toggle || !panel) return;

    function open() {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.hidden = true;
      document.body.style.overflow = '';
      toggle.focus();
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (scrim) scrim.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) shut();
    });
  }

  // Facets — auto-submit on change (progressive enhancement)
  function setupFacets() {
    var form = document.querySelector('[data-facets-form]');
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"], input[type="number"], select').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }


  // Actualités page — lightweight carousel and image lightbox.
  function setupActualitesPage() {
    document.querySelectorAll('[data-actualites-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-actualites-gallery-track]');
      var items = gallery.querySelectorAll('[data-actualites-lightbox-trigger]');
      var prev = gallery.querySelector('[data-actualites-gallery-prev]');
      var next = gallery.querySelector('[data-actualites-gallery-next]');
      var status = gallery.querySelector('[data-actualites-gallery-status]');
      if (!track || !items.length) return;

      var index = 0;
      function render() {
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (status) status.textContent = (index + 1) + '/' + items.length;
      }
      if (prev) prev.addEventListener('click', function () {
        index = index === 0 ? items.length - 1 : index - 1;
        render();
      });
      if (next) next.addEventListener('click', function () {
        index = index === items.length - 1 ? 0 : index + 1;
        render();
      });
      render();
    });

    var lightbox = document.querySelector('[data-actualites-lightbox]');
    var lightboxImage = lightbox ? lightbox.querySelector('[data-actualites-lightbox-image]') : null;
    var lastTrigger = null;
    if (!lightbox || !lightboxImage) return;

    function open(trigger) {
      var src = trigger.getAttribute('data-image-src');
      if (!src) return;
      lastTrigger = trigger;
      lightboxImage.setAttribute('src', src);
      lightboxImage.setAttribute('alt', trigger.getAttribute('data-image-alt') || '');
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = lightbox.querySelector('[data-actualites-lightbox-close]');
      if (close) close.focus();
    }
    function close() {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      lightboxImage.setAttribute('src', '');
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    document.querySelectorAll('[data-actualites-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () { open(trigger); });
    });
    lightbox.querySelectorAll('[data-actualites-lightbox-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  ready(function () {
    setupMobileNav();
    setupGallery();
    setupQuantity();
    setupVariantPicker();
    setupFacetsDrawer();
    setupFacets();
    setupContactMessageCounter();
    setupActualitesPage();
  });
})();
